import React, { useEffect } from "react";

import { useSceneObjectScopeStore } from "../../store/sceneObjectScopeStore";

// Restricts which scene objects a route adds to the THREE scene to the given uuids.
// Drop this into any route alongside ApartmentViewer (before it, so its effect commits first)
// to hide every other scene object in the loaded document, e.g. on the checklist item routes.
const SceneObjectScopeComponent = ({ uuids }: { uuids: string[] }) => {

  useEffect(() => {
    useSceneObjectScopeStore.getState().setScopedSceneObjectUuids(new Set(uuids));

    return () => {
      useSceneObjectScopeStore.getState().clearScope();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuids.join(",")]);

  return <>
  </>
}

export default SceneObjectScopeComponent;
